import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { deleteUserAccount } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';
import { currentUserShowSuccess } from '../../ducks/user.duck';

// ================ Action types ================ //

export const DELETE_ACCOUNT = {
  REQUEST: 'app/PersonalSettingsPage/DELETE_ACCOUNT_REQUEST',
  SUCCESS: 'app/PersonalSettingsPage/DELETE_ACCOUNT_SUCCESS',
  ERROR: 'app/PersonalSettingsPage/DELETE_ACCOUNT_ERROR',
};

// ================ Reducer ================ //

const initialState = {
  deleteAccountInProgress: false,
  deleteAccountError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ACCOUNT.REQUEST:
      return { ...state, deleteAccountInProgress: true, deleteAccountError: null };
    case DELETE_ACCOUNT.SUCCESS:
      return { ...state, deleteAccountInProgress: false, deleteAccountError: null };
    case DELETE_ACCOUNT.ERROR:
      return { ...state, deleteAccountInProgress: false, deleteAccountError: payload };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const deleteAccountInProgress = state => state.PersonalSettingsPage.deleteAccountInProgress;

// ================ Action creators ================ //

export const deleteAccountRequest = () => ({ type: DELETE_ACCOUNT.REQUEST });
export const deleteAccountSuccess = () => ({ type: DELETE_ACCOUNT.SUCCESS });
export const deleteAccountError = e => ({ type: DELETE_ACCOUNT.ERROR, error: true, payload: e });

// ================ Thunks ================ //

/**
 * Delete the current user's account.
 * Expects: params = { currentPassword: string }
 */
export const deleteAccount = params => async dispatch => {
  console.info('Delete account: started');
  dispatch(deleteAccountRequest());

  try {
    const response = await deleteUserAccount({ currentPassword: params?.currentPassword });

    // Expecting shape: { statusCode: number, message?: string, error?: string }
    if (response?.statusCode === 200) {
      console.info('Delete account: success');
      dispatch(deleteAccountSuccess());
      return response;
    }

    const apiMessage = response?.error || response?.message || 'Account deletion failed';
    const err = new Error(apiMessage);
    err.status = response?.statusCode;
    throw err;
  } catch (error) {
    const status = error?.status ?? error?.statusCode;
    let message = 'Account deletion failed';

    if (status === 400) message = 'Invalid password provided';
    else if (status >= 500) message = 'Server error occurred. Please try again later.';
    else if (error?.message) message = error.message;

    console.error('Delete account: failed', { status, message });

    const wrapped = new Error(message);
    wrapped.status = status;
    dispatch(deleteAccountError(storableError(wrapped)));
    throw wrapped;
  }
};

export const updateConsentSettings = actionPayload => {
  return (dispatch, getState, sdk) => {
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser.updateProfile(actionPayload, queryParams).then(
      response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }

        const currentUser = entities[0];
        dispatch(currentUserShowSuccess(currentUser));
        return currentUser;
      },
      error => {
        throw error;
      }
    );
  };
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  await dispatch(fetchCurrentUser());
};
